import {NgModule} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { InsightsV2Component } from './insights-v2.component';
import {
  InsightsDepartmentPerformanceModule
} from "../../insights-department-performance/insights-department-performance/insights-department-performance.module";


@NgModule({ declarations: [InsightsV2Component],
    exports: [InsightsV2Component], imports: [BrowserModule,
        FormsModule,
        InsightsDepartmentPerformanceModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class InsightsV2Module { }
